import EventIcon from '@mui/icons-material/Event';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

const StatItem = ({
  icon,
  label,
  value,
}: {
  icon: React.ReactNode;
  label: string;
  value: string;
}) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(2) }}>
      <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
        {icon}
      </Box>
      <Typography
        variant="subtitle2"
        sx={{ color: theme.palette.text.secondary, fontWeight: '400' }}
      >
        {label}: {value ? dayjs(value).format('MMM D, YYYY') : '-'}
      </Typography>
    </Box>
  );
};

interface ProjectStatsProps {
  createdOn: string;
  startedOn: string;
  completedOn: string;
  isLoading: boolean;
}

export const ProjectStats = ({
  createdOn,
  startedOn,
  completedOn,
  isLoading,
}: ProjectStatsProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
        <Skeleton variant="text" width="100%" height="80px" />
      </Box>
    );
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(6), p: theme.spacing(2) }}>
      <StatItem
        icon={<EventIcon sx={{ width: 16, height: 16 }} />}
        label={formatMessage({ id: 'adminProjects.projectDetails.stats.createdOn' })}
        value={createdOn}
      />
      <StatItem
        icon={<PlayArrowIcon sx={{ width: 16, height: 16 }} />}
        label={formatMessage({ id: 'adminProjects.projectDetails.stats.startedOn' })}
        value={startedOn}
      />
      <StatItem
        icon={<TaskAltIcon sx={{ width: 16, height: 16 }} />}
        label={formatMessage({ id: 'adminProjects.projectDetails.stats.completedOn' })}
        value={completedOn}
      />
    </Box>
  );
};
